module.exports = __webpack_public_path__ + "img/drkx1.f66323c6.png";